import * as v from 'valibot';

import {
  EAircraftEventStatus,
  EMaoMaintenanceBadge,
  EMaoMaintenanceName,
  ENOPOrganType,
} from '#shared';

import type { CCAircraftEvent } from '../types';

export const aircraftEventSchema: v.GenericSchema<CCAircraftEvent> = v.object({
  Id: v.string('Event ID is missing'),
  Type: v.enum(
    EAircraftEventStatus,
    issue => `@WARNING: Unexpected event type ${issue.input}`,
  ),
  EventTimeMs: v.number('Event time in milliseconds is missing'),
  EventTimeString: v.string('Event time string is missing'),
  StartTime: v.string('Start time is missing'),
  StartTimeUnix: v.number('Start time unix is missing'),
  EndTime: v.string('End time is missing'),
  EndTimeUnix: v.number('End time unix is missing'),
  Label: v.optional(v.string('Invalid label')),
  Organ: v.optional(
    v.object({
      id: v.string('Organ ID is missing'),
      name: v.enum(
        ENOPOrganType,
        issue => `@WARNING: Unexpected organ type ${issue.input}`,
      ),
      startPoint: v.number('Organ start point is missing'),
    }),
  ),
  IsLate: v.optional(v.boolean('Invalid late status')),
  MaintenanceType: v.optional(
    v.enum(
      EMaoMaintenanceBadge,
      issue => `@WARNING: Unexpected maintenance type ${issue.input}`,
    ),
  ),
  MaintenanceName: v.optional(
    v.enum(
      EMaoMaintenanceName,
      issue => `@WARNING: Unexpected maintenance name ${issue.input}`,
    ),
  ),
  isActual: v.boolean('Actual status is missing'),
});
